// extracted by mini-css-extract-plugin
export var closeButton = "PopoverInput-module--closeButton--2c6af";
export var closeIcon = "PopoverInput-module--closeIcon--ceedf";
export var container = "PopoverInput-module--container--e89c9";
export var filters = "PopoverInput-module--filters--e9208";
export var filtersInput = "PopoverInput-module--filtersInput--b269c";
export var filtersInputtextarea = "PopoverInput-module--filtersInputtextarea--5b85e";
export var icon = "PopoverInput-module--icon--b70f8";
export var input = "PopoverInput-module--input--52d7c";
export var inputContainer = "PopoverInput-module--inputContainer--f34dd";
export var inputWithIcon = "PopoverInput-module--inputWithIcon--6bf62";
export var inputWrapper = "PopoverInput-module--inputWrapper--c7f79";
export var label = "PopoverInput-module--label--8ec54";
export var open = "PopoverInput-module--open--e5a8d";
export var popover = "PopoverInput-module--popover--a8b05";
export var popoverOpen = "PopoverInput-module--popoverOpen--e9a81";
export var srOnly = "PopoverInput-module--srOnly--4ebb3";